import { Modal, Spinner, VisuallyHidden } from '@farol-ds/react'

import styles from './pre-loading-modal.module.scss'

export function PreLoadingModal() {
  return (
    <Modal open size="sm">
      <Modal.Content>
        <VisuallyHidden>
          <Modal.Header>
            <Modal.HeaderTitle>pre-loading-modal</Modal.HeaderTitle>
          </Modal.Header>
        </VisuallyHidden>
        <Modal.Body className={styles.center}>
          <Spinner data-testid="pre-loading-spinner" />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  )
}
